



























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat } from '@/utils/common'

@Component
export default class ModalEquipesProfissionalIncluir extends Vue {
  @Prop({ required: true, default: 'CREATE' }) mode: string

  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadAddRegraCalculoOperadora: boolean = false
  get loadingVincularEquipe() { return this.loadAddRegraCalculoOperadora }
  set loadingVincularEquipe(value: boolean) { this.loadAddRegraCalculoOperadora = value }

  get showModalEquipesProfissional() { return this.getRegrasDeCalculoStore.modal.equipesProfissional }
  set showModalEquipesProfissional(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'equipesProfissional', value }) }

  get equipesMedica() { return this.getRegrasDeCalculoStore.resumoEquipeMedica }

  get selectedEquipeMedica() { return this.getRegrasDeCalculoStore.selectedEquipeMedica }
  set selectedEquipeMedica(value: number) { this.getRegrasDeCalculoStore.setSelectedEquipeMedica(value) }

  async vinculaEquipeMedica() {
    this.loadingVincularEquipe = true
    
    const request = await this.getRegrasDeCalculoStore.postVinculoEquipeMedica()

    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingVincularEquipe = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `${this.mode === 'CREATE' ? 'Equipe vinculada com sucesso.' : 'Equipe atualizada com sucesso.'} ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingVincularEquipe = false
    this.showModalEquipesProfissional = false
  }

  @Watch('showModalEquipesProfissional')
  onChangeShowModalEquipesProfissional(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.setSelectedEquipeMedica('')
    }
  }
}
